<div class="component-card">
    <div style="display: inline-block;width: 100%;">
        <h1 class="component-title">{{'BUSINESS.PAYMENT_PROCESSORS'|translate}}</h1>
        <i class="pi pi-ellipsis-v spam-menu"></i>
    </div>
    <!-- <div class="panel_wrapper">
        <div class="d-flex flex-row justify-content-between pb-4">
            <div class="p-inputgroup div_search_field w-75">
                <button type="button" class="search_btn_icon"
                    (click)="searchPaymentProcessor(searchPaymentProcessorModel)"><i class="pi pi-search"></i></button>
                <input type="text" class="input_text_search_field"
                    (keydown.enter)="searchPaymentProcessor(searchPaymentProcessorModel)"
                    placeholder="{{'SEARCH' | translate}}...">
                <button type="button" class="search_btn_icon" (click)="clearSearch()"><i
                        class="pi pi-times"></i></button>
            </div>
        </div>
    </div> -->
</div>
<p-progressSpinner *ngIf="spinner" class="full_spinner"></p-progressSpinner>

<div class="mb-4" style="overflow-y: visible; max-width: 760px;">
    <div class="div_payment_processors">
        <div class="div_payment_processors_header">
            <div class="d-flex align-items-center">
              <span class="project_name">{{ 'BUSINESS.SPECIAL_OFFER' | translate }}</span>
            </div>
          </div>
    </div>
  <div *ngFor="let project of projectList" class="div_payment_processors">
    <div class="div_payment_processors_header">
      <div class="d-flex align-items-center">
        <div class="logo_project me-3">
          <img src="{{getLogoUrl(project.value)}}" alt="Logo">
        </div>
        <span class="project_name">{{project.name}}</span>
      </div>
    </div>
    <p-progressSpinner *ngIf="spinnerMap[project.value]" class="full_spinner_medium"></p-progressSpinner>
    <ng-container *ngIf="paymentProcessorListMap[project.value] && paymentProcessorListMap[project.value].length > 0">
      <div class="processors_div_grid" style="height: 412px; overflow-y: auto; overflow-x: hidden;" infiniteScroll
           [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000"
           (scrolled)="loadMorePaymentProcessors1(project.value)"
           [scrollWindow]="false">
        
        <div *ngFor="let paymentProcessor of paymentProcessorListMap[project.value]" class="vertical_component_card processor_card">
          <div class="component-list-card h-100 d-flex flex-column">
            <div class="text-center mt-3 mb-2 ">
                <label class="lbl_proc_name">{{paymentProcessor.paymentProcessorName}}</label><br>
                <label class="lbl_proc_web"><a href="{{paymentProcessor.processorWebUrl}}"
                        target="_blank">{{paymentProcessor.processorWebUrl}}</a></label>
                <div class="mt-4 div_cont_proc">
                    <div class="mb-3">
                        <label class="lbl_proc text-start w-100">{{ 'MEMBERS.MEMBERS' | translate | uppercase }}</label>
                        <label class="lbl_proc_content">{{paymentProcessor.numberOfMemberships}}</label>
                    </div>
                    <div class="mb-3">
                        <label class="lbl_proc text-start w-100">{{ 'BUSINESS.PAYMENTS' | translate | uppercase}}</label>
                        <label class="lbl_proc_content">{{paymentProcessor.numberOfPayments}}</label>
                    </div>
                </div>
                <label class="lbl_proc text-start w-100">{{ 'BUSINESS.PROCESSED' | translate | uppercase }}</label>
                <label class="lbl_proc_content">${{paymentProcessor.sumOfPayments}}</label>
            </div>
            <div class="w-100">
                <label class="lbl_proc text-start w-100">{{ 'BUSINESS.ASSIGNED_COUNTRY' | translate | uppercase}}</label>
                <label class="lbl_title w-100">{{paymentProcessor.countryIds.length}}</label>
            </div>
            <div class="mt-auto d-flex justify-content-between">
              <button class="btn_in_color w-100" (click)="ediPaymentProcessor(paymentProcessor.id,1)">{{ 'EDIT' |
                translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

